namespace Matrix.Rebalancer {
    export interface AccountOverrideRow {
        AccountCode?: string;
        Name?: string;
        AccountTypeCode?: string;
        AccountRoleCode?: string;
        ManagerCode?: string;
        BaseCurrency?: string;
        Tradeable?: boolean;
        ExternallyManaged?: boolean;
        CashOffsetSecurityId?: number;
        CashOffsetSecurityCode?: string;
        CashOffsetSecurityName?: string;
        MaxCash?: number;
        MinCash?: number;
        Deleted?: boolean;
        Class1?: string;
        Class2?: string;
        Class3?: string;
        Class4?: string;
        Class5?: string;
        Class6?: string;
        Class7?: string;
        Class8?: string;
        Class9?: string;
        Class10?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountName?: string;
        AccountRowId?: number;
        AccountTypeName?: string;
        AccountTypeRowId?: number;
        AccountRoleName?: string;
        AccountRoleRowId?: number;
        BaseCurrencyName?: string;
        BaseCurrencyRowId?: number;
    }

    export namespace AccountOverrideRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Rebalancer.AccountOverride';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            AccountCode = "AccountCode",
            Name = "Name",
            AccountTypeCode = "AccountTypeCode",
            AccountRoleCode = "AccountRoleCode",
            ManagerCode = "ManagerCode",
            BaseCurrency = "BaseCurrency",
            Tradeable = "Tradeable",
            ExternallyManaged = "ExternallyManaged",
            CashOffsetSecurityId = "CashOffsetSecurityId",
            CashOffsetSecurityCode = "CashOffsetSecurityCode",
            CashOffsetSecurityName = "CashOffsetSecurityName",
            MaxCash = "MaxCash",
            MinCash = "MinCash",
            Deleted = "Deleted",
            Class1 = "Class1",
            Class2 = "Class2",
            Class3 = "Class3",
            Class4 = "Class4",
            Class5 = "Class5",
            Class6 = "Class6",
            Class7 = "Class7",
            Class8 = "Class8",
            Class9 = "Class9",
            Class10 = "Class10",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountName = "AccountName",
            AccountRowId = "AccountRowId",
            AccountTypeName = "AccountTypeName",
            AccountTypeRowId = "AccountTypeRowId",
            AccountRoleName = "AccountRoleName",
            AccountRoleRowId = "AccountRoleRowId",
            BaseCurrencyName = "BaseCurrencyName",
            BaseCurrencyRowId = "BaseCurrencyRowId"
        }
    }
}
